import { render, staticRenderFns } from "./SolicitacaoAutorizacaoMaterial.vue?vue&type=template&id=e250ea8e&"
import script from "./SolicitacaoAutorizacaoMaterial.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoAutorizacaoMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports